// Copyright 2026, University of Maryland, All Rights Reserved

export const knowledgeBaseQueryKey = (
  orgId: string | undefined,
  wsId: string | undefined,
  instanceId: string | undefined,
) => ['knowledge-base', orgId, wsId, instanceId] as const
